import {
  WIX_BOOKINGS,
  PRICING_PLANS,
  WIX_NEW_STORES,
  WIX_RESTAURANTS_MENUS,
  WIX_RESTAURANTS_MENUS_NEW,
  WIX_RESTAURANTS_ORDERS,
  WIX_RESTAURANTS_ORDERS_NEW,
  WIX_RESTAURANTS_TABLE_RESERVATIONS,
  RESTAURANTS,
  WIX_HOTELS,
  WIX_STORES,
  WIX_DONATIONS,
  WIX_EVENTS,
} from '@wix/app-definition-ids';

export const LegalPage = {
  PrivacyPolicy: 'PrivacyPolicy',
  ShippingPolicy: 'ShippingPolicy',
  TermsAndConditions: 'TermsAndConditions',
  RefundPolicy: 'RefundPolicy',
  AccessibilityStatement: 'AccessibilityStatement',
} as const;

export const DEFAULT_LEGAL_PAGES = [
  LegalPage.PrivacyPolicy,
  LegalPage.AccessibilityStatement,
];

const BUSINESS_VERTICALS_LEGAL_PAGES = [
  LegalPage.PrivacyPolicy,
  LegalPage.TermsAndConditions,
  LegalPage.RefundPolicy,
  LegalPage.AccessibilityStatement,
];

const STORES_LEGAL_PAGES = [
  LegalPage.PrivacyPolicy,
  LegalPage.ShippingPolicy,
  LegalPage.TermsAndConditions,
  LegalPage.RefundPolicy,
  LegalPage.AccessibilityStatement,
];

const DONATIONS_LEGAL_PAGES = [
  LegalPage.PrivacyPolicy,
  LegalPage.TermsAndConditions,
  LegalPage.AccessibilityStatement,
];

export const LEGAL_PAGES_TO_APPS: Record<string, (keyof typeof LegalPage)[]> = {
  [WIX_BOOKINGS]: BUSINESS_VERTICALS_LEGAL_PAGES,
  [WIX_EVENTS]: BUSINESS_VERTICALS_LEGAL_PAGES,
  [WIX_RESTAURANTS_MENUS]: BUSINESS_VERTICALS_LEGAL_PAGES,
  [WIX_RESTAURANTS_MENUS_NEW]: BUSINESS_VERTICALS_LEGAL_PAGES,
  [WIX_RESTAURANTS_ORDERS]: BUSINESS_VERTICALS_LEGAL_PAGES,
  [WIX_RESTAURANTS_ORDERS_NEW]: BUSINESS_VERTICALS_LEGAL_PAGES,
  [WIX_RESTAURANTS_TABLE_RESERVATIONS]: BUSINESS_VERTICALS_LEGAL_PAGES,
  [RESTAURANTS]: BUSINESS_VERTICALS_LEGAL_PAGES,
  [WIX_HOTELS]: BUSINESS_VERTICALS_LEGAL_PAGES,
  [PRICING_PLANS]: BUSINESS_VERTICALS_LEGAL_PAGES,
  [WIX_STORES]: STORES_LEGAL_PAGES,
  [WIX_NEW_STORES]: STORES_LEGAL_PAGES,
  [WIX_DONATIONS]: DONATIONS_LEGAL_PAGES,
};

const LegalPagesENIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: '989aafea-ea52-4a11-bed9-afdf25da6fd5',
  [LegalPage.ShippingPolicy]: 'a480fd94-cb79-481a-bccb-19b9d53fecb7',
  [LegalPage.TermsAndConditions]: 'b506929d-e622-46d7-bc5d-b75184c7519d',
  [LegalPage.RefundPolicy]: 'a624b4e0-d95e-40d2-8612-b972226b38f3',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

const LegalPagesKOIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: '0c6c7c8c-38c8-4a0b-8560-287704440644',
  [LegalPage.ShippingPolicy]: '9e2c900c-05c9-4525-9b79-b990bfd67040',
  [LegalPage.TermsAndConditions]: '82ed5d7b-9a67-4d10-8ff1-d59160bb3491',
  [LegalPage.RefundPolicy]: 'fa628dea-803f-4ee4-a102-3fdaa11cabd8',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

const LegalPagesRUIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: '99045219-c731-4c0c-bd6e-734d8e66b00e',
  [LegalPage.ShippingPolicy]: 'ae41d210-a047-46f8-a05b-37fe8a9be7ca',
  [LegalPage.TermsAndConditions]: 'bd044b88-595a-4d50-96f5-16d3be3a3770',
  [LegalPage.RefundPolicy]: '613c47d4-858b-41f8-96d4-d47dcb8b96e3',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

const LegalPagesIDIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: '6c0f336d-eb69-4554-90b2-b5e99af4dcdf',
  [LegalPage.ShippingPolicy]: 'cab0da55-c879-46c5-bdbf-c0a8432c1e2b',
  [LegalPage.TermsAndConditions]: '6a9fc1b0-c221-4108-b4b6-195b6cecf84f',
  [LegalPage.RefundPolicy]: '46120cb6-f690-47fa-b732-94828a4d5d9b',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

const LegalPagesVIIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: '104e2ba6-3f0c-4320-b9c3-c097b49a5ab4',
  [LegalPage.ShippingPolicy]: '1eeb438d-cc54-4e22-bdc4-8250fdb059ff',
  [LegalPage.TermsAndConditions]: '5b3f78cb-6323-474a-8c41-0da53b86284c',
  [LegalPage.RefundPolicy]: '09d7168b-fd64-49d4-a126-ab80821c6671',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

const LegalPagesUKIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: '5e1fc8c6-64fb-4707-a803-7917fa149612',
  [LegalPage.ShippingPolicy]: '281e3b46-406f-476a-b1ce-0ef27a818efb',
  [LegalPage.TermsAndConditions]: '9b1cff85-8d87-410d-ba78-67741aba0479',
  [LegalPage.RefundPolicy]: '3efa5f86-70e6-4074-a4a1-ab93f96c16ac',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

const LegalPagesTHIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: '42496789-4833-44b3-a4d5-c856878752b7',
  [LegalPage.ShippingPolicy]: 'a3b5eef6-19fa-49b3-a4ae-1ea4a61c13c3',
  [LegalPage.TermsAndConditions]: 'fa7b6990-e862-4e5a-9f11-73781b5798a8',
  [LegalPage.RefundPolicy]: 'f85822ac-ce01-4d2d-8496-9011f467e9f1',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

const LegalPagesCSIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: '265337c7-d084-4ab2-ac67-30510d43b931',
  [LegalPage.ShippingPolicy]: 'edbf7e46-e92a-4397-9805-1e9c334fc312',
  [LegalPage.TermsAndConditions]: '898ea3ea-bd36-40ef-834b-8ee6c8102cac',
  [LegalPage.RefundPolicy]: 'a344ffee-2c8a-4f8e-82d2-03cf0f43b324',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

const LegalPagesNOIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: 'd7a5a2f2-ac88-4082-8725-2d37e357364f',
  [LegalPage.ShippingPolicy]: '62e957bc-2864-4d42-b86b-28604b477527',
  [LegalPage.TermsAndConditions]: '07013f16-12ae-4974-a99f-3939b5450406',
  [LegalPage.RefundPolicy]: '289ca3f9-c5ca-49c0-b17a-cded4d5114f3',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

const LegalPagesDAIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: 'e7197e85-c8ba-47f9-be9c-d06c096386c6',
  [LegalPage.ShippingPolicy]: 'd6d063f6-498f-49c8-a16e-646109dabc7f',
  [LegalPage.TermsAndConditions]: '608abf79-9be8-4950-9834-80932a482d16',
  [LegalPage.RefundPolicy]: 'b7ae4771-a063-4a6a-8375-88fb55dca6bd',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

const LegalPagesSVIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: '62c7573f-b8c6-48fa-aa0a-e4463833b356',
  [LegalPage.ShippingPolicy]: '31a199a2-9f25-4d4d-864e-38ee63c7a862',
  [LegalPage.TermsAndConditions]: '658fe5d2-32ee-4fe4-9b28-4603ed30f9b6',
  [LegalPage.RefundPolicy]: '48c498a3-df81-4632-8e82-64136ee56dd1',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

const LegalPagesPLIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: '52194703-7fb7-4541-a37c-2e64ecbb4a23',
  [LegalPage.ShippingPolicy]: '300a0f54-f91a-4a56-8343-b26c9d32307f',
  [LegalPage.TermsAndConditions]: '9dbfea72-7723-4908-a6d8-49389a2a8ad9',
  [LegalPage.RefundPolicy]: '3df5d963-c904-4040-8437-f2a3ff84e0d1',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

const LegalPagesESIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: '64ab9842-13f5-4ec1-9728-e4bcafb802ca',
  [LegalPage.ShippingPolicy]: '997e040d-e8cd-479f-b991-eebd0b0af856',
  [LegalPage.TermsAndConditions]: 'f9b3802b-7666-49d0-98e7-310ac5747a2b',
  [LegalPage.RefundPolicy]: 'f76ce7d6-2ba7-425f-bc6a-f155e0aae562',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

const LegalPagesPTIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: '139f8cf1-ad51-4f9c-bce0-4b367cc65b4f',
  [LegalPage.ShippingPolicy]: '600fc7d0-32ba-4b2b-9084-5e738ae0960e',
  [LegalPage.TermsAndConditions]: '0e06dd08-1ad6-4ca3-859b-d7aba8928eae',
  [LegalPage.RefundPolicy]: '25769f14-86a7-46b1-9e94-e4ab8a806b51',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

const LegalPagesNLIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: '01268323-3931-4bad-bb4b-08bd59f2ac11',
  [LegalPage.ShippingPolicy]: 'ccf3de77-5326-4133-bd39-6d3eef3e8cb8',
  [LegalPage.TermsAndConditions]: '84ff126a-b66c-45b0-b0b2-16208b6fc956',
  [LegalPage.RefundPolicy]: '0f0c3807-6bab-484f-8384-78a5149a6c80',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

const LegalPagesDEIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: '339deeac-0708-4a9f-b211-0bd754c7adbf',
  [LegalPage.ShippingPolicy]: '3a567149-8549-4c8e-a3df-b5019bf4ae30',
  [LegalPage.TermsAndConditions]: 'db2be023-0dbd-453d-917c-fcc763fe490a',
  [LegalPage.RefundPolicy]: 'fc5ef959-60a7-456c-90ad-38e2b46c1e46',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

const LegalPagesJAIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: 'b8024edb-bbd5-4676-be03-b173ad027be3',
  [LegalPage.ShippingPolicy]: '54d6d322-f334-48d7-bf0a-76d55d55511b',
  [LegalPage.TermsAndConditions]: 'ef1f9e83-f847-40e9-897e-758f12427289',
  [LegalPage.RefundPolicy]: '92336a11-b294-4554-a79e-a6da4cef3705',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

const LegalPagesFRIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: '62896f24-067b-4036-89ba-eef1fea3b89e',
  [LegalPage.ShippingPolicy]: '587c7491-14c8-42ee-aa8a-3f5e34cf97c5',
  [LegalPage.TermsAndConditions]: 'c8c66f41-c312-4bc6-8cd8-b09895adc5cb',
  [LegalPage.RefundPolicy]: '6967b1f7-8ee4-48cb-bec8-d3893d4c05a2',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

const LegalPagesITIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: '989aafea-ea52-4a11-bed9-afdf25da6fd5', // TODO: check it
  [LegalPage.ShippingPolicy]: 'b376e5cd-aaa0-4e5a-92ce-e7c676512aad',
  [LegalPage.TermsAndConditions]: '43391ba0-c540-462c-886f-e04a5f16eca9',
  [LegalPage.RefundPolicy]: '5f74a9fb-51f7-4029-88c0-508ab9cbb5c6',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

const LegalPagesTRIds: Record<keyof typeof LegalPage, string> = {
  [LegalPage.PrivacyPolicy]: '463f1ed2-2e3c-4777-a8dc-75cb63f3d54d',
  [LegalPage.ShippingPolicy]: '1785557d-845a-44da-8c99-056b17fd2afc',
  [LegalPage.TermsAndConditions]: 'bc4b890b-65e0-43ec-9fd0-f4705c1bfa1a',
  [LegalPage.RefundPolicy]: '4d26a8e7-ca36-4411-ba5b-312f8e10d512',
  [LegalPage.AccessibilityStatement]: '17880b69-3886-45f0-a636-4c0b003eabf8',
};

export const LEGAL_PAGES_BY_LANG = {
  de: LegalPagesDEIds,
  en: LegalPagesENIds,
  es: LegalPagesESIds,
  fr: LegalPagesFRIds,
  it: LegalPagesITIds,
  ja: LegalPagesJAIds,
  ko: LegalPagesKOIds,
  pl: LegalPagesPLIds,
  ru: LegalPagesRUIds,
  nl: LegalPagesNLIds,
  tr: LegalPagesTRIds,
  sv: LegalPagesSVIds,
  pt: LegalPagesPTIds,
  no: LegalPagesNOIds,
  da: LegalPagesDAIds,
  cs: LegalPagesCSIds,
  th: LegalPagesTHIds,
  uk: LegalPagesUKIds,
  vi: LegalPagesVIIds,
  id: LegalPagesIDIds,
} as const;
